import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { fetchOfferDeliverables } from './offerDeliverables';

import type { Action, Deliverable, Dispatch, SubcampaignOffer, ThunkAction } from 'types';

const COPIED = 'offerDetailsBuffer/COPIED';
const RESET = 'offerDetailsBuffer/RESET';

type State = {
  copiedOfferDetails: null | ({
    offer: SubcampaignOffer,
    deliverables: Array<Deliverable>
  })
};

const initialState: State = {
  copiedOfferDetails: null
};

export function offerDetailsCopied(offer: SubcampaignOffer, deliverables: Array<Deliverable>): Action {
  return {
    type: COPIED,
    payload: {
      offer,
      deliverables
    }
  };
}

export function offerDetailsPasted(): Action {
  return {
    type: RESET,
    payload: {}
  };
}

export function copyOfferDetailsWithDeliverables(offer: SubcampaignOffer): ThunkAction {
  return async (dispatch: Dispatch) => {
    const deliverables = await dispatch(fetchOfferDeliverables(offer.id, false));

    dispatch(offerDetailsCopied(offer, deliverables));
  };
}

export default createReducer<State, any>('offerDetailsBuffer', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [COPIED]: (state, { offer, deliverables }) => ({
    ...state,
    copiedOfferDetails: {
      offer,
      deliverables
    }
  })
});
